<template>
    <div
        class="flex w-full cursor-pointer gap-3 px-4 py-2"
        :class="{
            'bg-muval-gray-5': isActive,
            'bg-muval-gray-6': !isActive,
        }"
        @mouseenter="isHovering = true"
        @mouseleave="isHovering = false"
    >
        <SvgIcon
            name="system-pin"
            class="my-auto size-6 text-brand"
            :class="{ grayscale: !isActive, '': isActive }"
        />
        <div class="my-auto flex flex-col">
            <span>
                <MakeBold
                    :matchedSubStrings="option.structured_formatting.main_text_matched_substrings"
                    :text="option?.structured_formatting?.main_text"
                />
            </span>
            <span class="text-xs">
                {{ option?.structured_formatting?.secondary_text }}
            </span>
        </div>
    </div>
</template>

<script setup>
import MakeBold from './MakeBold.vue';

defineProps({
    option: {
        type: Object,
        required: true,
    },
    selectedValue: {
        type: String,
        required: true,
    },
    isActive: {
        type: Boolean,
        default: false,
    },
});
</script>
